import { useState, useEffect } from "react";
import { LineChart, Line, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import { IoCaretDown, IoCaretUp } from "react-icons/io5";
import { getAccountSignupsAsync } from "../../../services/dashboardService";
import moment from "moment";
import _ from "lodash";

const DailySignups = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [previousCount, setPreviousCount] = useState(0);
  const [currentCount, setCurrentCount] = useState(0);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      setIsLoading(true);

      const start_date = moment().subtract(6, "days").format("MM-DD-yyyy");
      const end_date = moment().format("MM-DD-yyyy");

      const { result } = await getAccountSignupsAsync(1, start_date, end_date);

      if (mounted) {
        const items = result.map((item) => {
          item["start_date"] = moment(item.start_date).format("LL");
          item["Count"] = item.total_count;

          return item;
        });

        const current = result[items.length - 1].total_count;
        const previous = result[items.length - 2].total_count;

        setData(items);
        setPreviousCount(previous);
        setCurrentCount(current);
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  const renderFeedback = () => {
    if (currentCount > previousCount)
      return (
        <>
          <IoCaretUp className="text-green-500 mr-1" />
          <p className="text-green-500">
            {currentCount - previousCount}
            <span className="text-gray-400 ml-2">from yesterday's signups</span>
          </p>
        </>
      );

    if (currentCount < previousCount)
      return (
        <>
          <IoCaretDown className="text-red-500 mr-1" />
          <p className="text-red-500">
            {Math.abs(currentCount - previousCount)}
            <span className="text-gray-400 ml-2">from yesterday's signups</span>
          </p>
        </>
      );

    return (
      <span className="text-gray-400">No changes from yesterday's signups</span>
    );
  };

  return (
    <div className="card p-0">
      <div className="flex justify-between p-6">
        <div>
          <p className="text-gray-500">Daily Signups</p>
          <div className="flex items-center text-sm mt-2">
            {renderFeedback()}
          </div>
        </div>
        <p className="text-blue-400 font-bold text-lg">{currentCount}</p>
      </div>
      {isLoading && (
        <div className="flex justify-center items-center space-x-1 h-20">
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
        </div>
      )}
      {!isLoading && (
        <ResponsiveContainer width="100%" height={50} className="mt-5">
          <LineChart
            width={300}
            height={100}
            data={data}
            margin={{ top: 5, left: 0, right: 0, bottom: 5 }}
          >
            <Line
              type="monotone"
              dataKey="Count"
              stroke="#60a5fa"
              strokeWidth={2}
              dot={false}
            />
            <Tooltip
              labelFormatter={(value, data) => {
                if (!_.isEmpty(data)) {
                  const { start_date } = data[0].payload;

                  return start_date;
                }
              }}
            />
            <XAxis hide={true} scale="point" />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default DailySignups;
